var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.842 21.3833H19.8648C17.3585 21.3833 15.3194 19.3442 15.3194 16.8379C15.3194 14.3316 17.3585 12.2926 19.8648 12.2926H23.842C24.156 12.2926 24.4102 12.0384 24.4102 11.7244V10.0199C24.4102 8.8284 23.486 7.85944 22.3184 7.76547L19.0553 2.06599C18.7529 1.53887 18.2646 1.16212 17.6803 1.00568C17.0988 0.8503 16.4907 0.931903 15.9703 1.23483L4.7842 7.74715H2.81958C1.56618 7.74715 0.546875 8.7664 0.546875 10.0199V23.656C0.546875 24.9094 1.56612 25.9287 2.81958 25.9287H22.1375C23.3909 25.9287 24.4102 24.9095 24.4102 23.656V21.9515C24.4102 21.6374 24.156 21.3833 23.842 21.3833ZM19.7599 5.58476L20.9979 7.74715H16.0457L19.7599 5.58476ZM7.04269 7.74715L16.5423 2.2169C16.7992 2.06653 17.0993 2.02658 17.3862 2.10317C17.6764 2.18084 17.9184 2.36839 18.0687 2.63083L18.0699 2.63291L9.28578 7.74715H7.04269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8433 13.4287H19.8661C17.9862 13.4287 16.457 14.9579 16.457 16.8377C16.457 18.7176 17.9862 20.2468 19.8661 20.2468H23.8433C24.7832 20.2468 25.5478 19.4822 25.5478 18.5423V15.1332C25.5478 14.1933 24.7832 13.4287 23.8433 13.4287ZM19.8661 17.9741C19.2397 17.9741 18.7297 17.4642 18.7297 16.8377C18.7297 16.2113 19.2397 15.7014 19.8661 15.7014C20.4925 15.7014 21.0024 16.2113 21.0024 16.8377C21.0024 17.4642 20.4925 17.9741 19.8661 17.9741Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.546875 0.928711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.5239e55cdbdae110df536402ab8be250.svg";
export { ForwardRef as ReactComponent };